import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Logo from '../../../../components/Logo';
import NavLogo from '../../../../components/NavLogo';
import ChildHeaderBanner from '../../../../layouts/ChildHeaderBanner';
import CustomTabs from '../../../../layouts/CustomTabs';
import { useDispatch, useSelector } from 'react-redux';
import {
  getProducer,
  getEntity,
  getOfferDetails,
  updateOfferStatus,
} from '../../../../utils/actions';
import DocumentViewer from '../../../../layouts/DocumentViewer';
import * as app_consts from '../../../../utils/constants';
import YesNoModal from '../../../../components/modals/YesNoModal';

const MartketOfferDetails = () => {
  const [activeTab, setActiveTab] = useState('Offer Details');

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const producer = useSelector((state) => state.getProducer.data);
  const offer = useSelector((state) => state.getOfferDetails.data);
  const entity = useSelector((state) => state.getEntity.data);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [actionStatus, setActionStatus] = useState(null);

  const offerId = id;


  const commodityOrder = offer?.commodity_order[0];
  const brokerProfile = offer?.profile;

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleOfferActions = async (status) => {
    // Open the modal to confirm the action
    setActionStatus(status);
    setModalOpen(true);
  };

  const closeModal = () => {
    // Close the modal without performing the action
    setModalOpen(false);
  };

  const confirmAction = async () => {
    setModalOpen(false);
    // Proceed with the action
    if (actionStatus)
    {
      try
      {
        await dispatch(
          updateOfferStatus({
            commodity_order_id: commodityOrder.id,
            commodity_order_status: actionStatus,
          })
        );
        setLoading(false);
        window.location.reload();
      } catch (error)
      {
        // Handle error
        setErrors('An unexpected error occurred.');
      }
    }
  };

  // GET OFFER DETAILS
  useEffect(() => {
    const fetchOfferDetails = async () => {
      setLoading(true);
      try
      {
        await dispatch(getOfferDetails(offerId));
      } catch (error)
      {
      } finally
      {
        setLoading(false);
      }
    };
    fetchOfferDetails();
  }, [dispatch, id]);

  useEffect(() => {
    const fetchProducerAndEntity = async () => {
      setLoading(true);
      try
      {
        const producerData = await dispatch(getProducer(id));

        const entityID = producerData?.entity_id;

        if (entityID)
        {
          const entityData = await dispatch(getEntity(entityID));
        }
      } catch (error)
      {
        console.error(error);
      } finally
      {
        setLoading(false);
      }
    };

    fetchProducerAndEntity();
  }, [dispatch, id]);

  const tabs = [
    { title: 'Offer Details', disabled: false },
    entity ? { title: 'Entity Details', disabled: false } : null,
  ].filter((tab) => tab !== null);

  // Handle Logout
  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };

  return (
    <div>
      <button
        data-drawer-target='logo-sidebar'
        data-drawer-toggle='logo-sidebar'
        aria-controls='logo-sidebar'
        type='button'
        className='inline-flex items-center p-2 mt-2 ml-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600'
      >
        <span className='sr-only'>Open sidebar</span>
        <svg
          className='w-6 h-6'
          aria-hidden='true'
          fill='currentColor'
          viewBox='0 0 20 20'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            clip-rule='evenodd'
            fill-rule='evenodd'
            d='M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z'
          ></path>
        </svg>
        <NavLogo />
      </button>

      <aside
        id='logo-sidebar'
        className='fixed top-0 left-0 z-40 w-64 h-screen transition-transform -translate-x-full sm:translate-x-0'
        aria-label='Sidebar'
      >
        <div className='h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-gray-800'>
          <a href='/' className='flex items-center pl-2.5 mb-5'>
            <Logo />
          </a>
          <ul className='space-y-2 font-medium'>
            <li>
              <a
                href='/home'
                className='flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
              >
                <svg
                  class='w-6 h-6  dark:text-white'
                  aria-hidden='true'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 18 18'
                >
                  <path
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    d='M6.143 1H1.857A.857.857 0 0 0 1 1.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 6.143V1.857A.857.857 0 0 0 6.143 1Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 17 6.143V1.857A.857.857 0 0 0 16.143 1Zm-10 10H1.857a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286A.857.857 0 0 0 7 16.143v-4.286A.857.857 0 0 0 6.143 11Zm10 0h-4.286a.857.857 0 0 0-.857.857v4.286c0 .473.384.857.857.857h4.286a.857.857 0 0 0 .857-.857v-4.286a.857.857 0 0 0-.857-.857Z'
                  />
                </svg>
                <span className='ml-3'>My Dashboards</span>
              </a>
            </li>

            <li>
              <a href={`/exchange/markets`} className="flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z" />
                </svg>
                <span className="ml-3">ATS</span>
              </a>
            </li>

            <li>
              <a className='cursor-not-allowed flex items-center p-2 text-gray-400 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'>
                <svg
                  class='w-6 h-6 dark:text-white'
                  aria-hidden='true'
                  viewBox='0 0 20 18'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M6.5 8C5.80777 8 5.13108 7.79473 4.55551 7.41015C3.97993 7.02556 3.53133 6.47893 3.26642 5.83939C3.00152 5.19985 2.9322 4.49612 3.06725 3.81719C3.2023 3.13825 3.53564 2.51461 4.02513 2.02513C4.51461 1.53564 5.13825 1.2023 5.81719 1.06725C6.49612 0.932205 7.19985 1.00152 7.83939 1.26642C8.47893 1.53133 9.02556 1.97993 9.41015 2.55551C9.79473 3.13108 10 3.80777 10 4.5'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M6.5 17H1V15C1 13.9391 1.42143 12.9217 2.17157 12.1716C2.92172 11.4214 3.93913 11 5 11'
                    stroke='currentColor'
                    stroke-width='2'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                  <path
                    d='M19.5 11H18.38C18.2672 10.5081 18.0714 10.0391 17.801 9.613L18.601 8.818C18.6947 8.72424 18.7474 8.59708 18.7474 8.4645C18.7474 8.33192 18.6947 8.20476 18.601 8.111L17.894 7.404C17.8002 7.31026 17.6731 7.25761 17.5405 7.25761C17.4079 7.25761 17.2808 7.31026 17.187 7.404L16.392 8.204C15.9647 7.93136 15.4939 7.73384 15 7.62V6.5C15 6.36739 14.9473 6.24021 14.8536 6.14645C14.7598 6.05268 14.6326 6 14.5 6H13.5C13.3674 6 13.2402 6.05268 13.1464 6.14645C13.0527 6.24021 13 6.36739 13 6.5V7.62C12.5081 7.73283 12.0391 7.92863 11.613 8.199L10.818 7.404C10.7242 7.31026 10.5971 7.25761 10.4645 7.25761C10.3319 7.25761 10.2048 7.31026 10.111 7.404L9.404 8.111C9.31026 8.20476 9.25761 8.33192 9.25761 8.4645C9.25761 8.59708 9.31026 8.72424 9.404 8.818L10.204 9.618C9.9324 10.0422 9.73492 10.5096 9.62 11H8.5C8.36739 11 8.24021 11.0527 8.14645 11.1464C8.05268 11.2402 8 11.3674 8 11.5V12.5C8 12.6326 8.05268 12.7598 8.14645 12.8536C8.24021 12.9473 8.36739 13 8.5 13H9.62C9.73283 13.4919 9.92863 13.9609 10.199 14.387L9.404 15.182C9.31026 15.2758 9.25761 15.4029 9.25761 15.5355C9.25761 15.6681 9.31026 15.7952 9.404 15.889L10.111 16.596C10.2048 16.6897 10.3319 16.7424 10.4645 16.7424C10.5971 16.7424 10.7242 16.6897 10.818 16.596L11.618 15.796C12.0422 16.0676 12.5096 16.2651 13 16.38V17.5C13 17.6326 13.0527 17.7598 13.1464 17.8536C13.2402 17.9473 13.3674 18 13.5 18H14.5C14.6326 18 14.7598 17.9473 14.8536 17.8536C14.9473 17.7598 15 17.6326 15 17.5V16.38C15.4919 16.2672 15.9609 16.0714 16.387 15.801L17.182 16.601C17.2758 16.6947 17.4029 16.7474 17.5355 16.7474C17.6681 16.7474 17.7952 16.6947 17.889 16.601L18.596 15.894C18.6897 15.8002 18.7424 15.6731 18.7424 15.5405C18.7424 15.4079 18.6897 15.2808 18.596 15.187L17.796 14.392C18.0686 13.9647 18.2662 13.4939 18.38 13H19.5C19.6326 13 19.7598 12.9473 19.8536 12.8536C19.9473 12.7598 20 12.6326 20 12.5V11.5C20 11.3674 19.9473 11.2402 19.8536 11.1464C19.7598 11.0527 19.6326 11 19.5 11ZM14 14.5C13.5055 14.5 13.0222 14.3534 12.6111 14.0787C12.2 13.804 11.8795 13.4135 11.6903 12.9567C11.5011 12.4999 11.4516 11.9972 11.548 11.5123C11.6445 11.0273 11.8826 10.5819 12.2322 10.2322C12.5819 9.8826 13.0273 9.6445 13.5123 9.54804C13.9972 9.45157 14.4999 9.50108 14.9567 9.6903C15.4135 9.87952 15.804 10.2 16.0787 10.6111C16.3534 11.0222 16.5 11.5055 16.5 12C16.5 12.663 16.2366 13.2989 15.7678 13.7678C15.2989 14.2366 14.663 14.5 14 14.5Z'
                    fill='currentColor'
                  />
                </svg>

                <span className='flex-1 ml-3 whitespace-nowrap'>
                  My Profile
                </span>
              </a>
            </li>
            <li className='my-2 fixed bottom-12 w-11/12'>
              <a
                onClick={handleLogout}
                className='cursor-pointer flex items-center p-2 text-gray-600 hover:text-green-600 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group'
              >
                <svg
                  class='w-6 h-6 dark:text-white'
                  aria-hidden='true'
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 16 16'
                >
                  <path
                    stroke='currentColor'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                    stroke-width='2'
                    d='M4 8h11m0 0-4-4m4 4-4 4m-5 3H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h3'
                  />
                </svg>
                <span className='flex-1 ml-3 whitespace-nowrap'>Sign Out</span>
              </a>
            </li>
          </ul>
        </div>
      </aside>

      <div className='p-4 sm:ml-64'>
        <div className='p-4 rounded-lg dark:border-gray-700'>
          <ChildHeaderBanner
            title='Offer Details' /* producer={contact_name}  */
          />

          <div className='relative'>
            <CustomTabs
              tabs={tabs}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              type={app_consts.OFFER_MANAGEMENT}
              home={`home`}
            />
            <br />
            {activeTab === 'Offer Details' && (
              <div>
                <div class='relative overflow-hidden bg-white dark:bg-gray-800 sm:rounded-lg'>
                  <div class='flex-row items-center justify-between p-4 space-y-3 sm:flex sm:space-y-0 sm:space-x-4'>
                    <div>
                      {/* <h5 class="mr-3 font-semibold dark:text-white">{contact_name}</h5> */}
                      {/* <p class="text-gray-500 dark:text-gray-400">Contact Information</p> */}
                    </div>
                    <div class='flex flex-col items-stretch justify-end flex-shrink-0 w-full space-y-2 md:w-auto md:flex-row md:space-y-0 md:items-center md:space-x-3'>
                      {/* <button type="button" onClick={openModal} class="flex items-center justify-center px-4 py-2 text-sm font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 dark:bg-primary-600 dark:hover:bg-primary-700 focus:outline-none dark:focus:ring-primary-800">
                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-5 h-5">
                                                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clip-rule="evenodd" />
                                                </svg>

                                                Activate Membership Type
                                            </button> */}
                      <div className='relative inline-block text-left'>
                        <div>
                          <button
                            type='button'
                            onClick={toggleDropdown}
                            className='inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg md:w-auto focus:outline-none hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700'
                            id='actionsDropdownButton'
                          >
                            <svg
                              className='-ml-1 mr-1.5 w-5 h-5'
                              fill='currentColor'
                              viewBox='0 0 20 20'
                              xmlns='http://www.w3.org/2000/svg'
                              aria-hidden='true'
                            >
                              <path
                                clipRule='evenodd'
                                fillRule='evenodd'
                                d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z'
                              />
                            </svg>
                            Actions
                          </button>
                        </div>
                        {isOpen && (
                          <div
                            className='origin-top-right absolute right-0 mt-2 w-44 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-gray-700 dark:ring-gray-600'
                            role='menu'
                            aria-orientation='vertical'
                            aria-labelledby='actionsDropdownButton'
                          >
                            <div className='py-1' role='none'>
                              <button
                                onClick={() => handleOfferActions('open')}
                                className='block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white'
                                role='menuitem'
                              >
                                Approve
                              </button>
                              <button
                                onClick={() => handleOfferActions('rejected')}
                                className='block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white'
                                role='menuitem'
                              >
                                Reject
                              </button>
                              <button
                                onClick={() => handleOfferActions('withdrawn')}
                                className='block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white'
                                role='menuitem'
                              >
                                Withdraw
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <dl className='grid grid-cols-2 gap-4 mb-4'>
                    {/* <div className="col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600">
                                            <dt className="mb-2 font-semibold leading-none text-gray-900 dark:text-white">Buyer ID</dt>
                                            <dd className="flex items-center text-gray-500 dark:text-gray-400">

                                                {offer?.producer_id}
                                            </dd>
                                        </div> */}
                    {/* <div className="col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600">
                                            <dt className="mb-2 font-semibold leading-none text-gray-900 dark:text-white">Contact Name</dt>
                                            <dd className="flex items-center text-gray-500 dark:text-gray-400">

                                                {offer?.contact_name}
                                            </dd>
                                        </div> */}
                    {/* <div className="col-span-2 p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 sm:col-span-1 dark:border-gray-600">
                                            <dt className="mb-2 font-semibold leading-none text-gray-900 dark:text-white">Contact Email</dt>
                                            <dd className="flex items-center text-gray-500 dark:text-gray-400">

                                                {offer?.contact_email}
                                            </dd>
                                        </div> */}
                    {/* <div className="p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600"><dt className="mb-2 font-semibold leading-none text-gray-900 dark:text-white">Contact Phone Number</dt><dd className="flex items-center text-gray-500 dark:text-gray-400">{offer?.contact_phone}</dd></div> */}
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Broker Name
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {brokerProfile?.name}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Offer Reference No
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {commodityOrder?.commodity_order_reference_no}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Order Type
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.order_type.toUpperCase()}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Status
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        <span className='bg-yellow-100 text-yellow-800'>
                          {commodityOrder?.status.replace(/_/g, ' ').toUpperCase()}
                        </span>
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Commodities
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.commodity.replace(/_/g, ' ').toUpperCase()}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Quality
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.quality.toUpperCase()}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Volume
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.volume}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Requested Unit Price
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.requested_unit_price}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Location
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.location}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Delivery
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.delivery}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Unit Of Measure
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.unit_of_measure}
                      </dd>
                    </div>
                    <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                      <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                        Special Terms and Conditions
                      </dt>
                      <dd className='text-gray-500 dark:text-gray-400'>
                        {offer?.special_terms_and_conditions}
                      </dd>
                    </div>
                  </dl>
                </div>
                <YesNoModal
                  isOpen={modalOpen}
                  closeFunction={closeModal}
                  modalTitle='Confirmation'
                  modalMessage='Are you sure you want to perform this action?'
                  cancelButtonLabel='Cancel'
                  agreeButtonLabel='Agree'
                  agreeClickFunction={confirmAction}
                />
              </div>
            )}
            {entity ? (
              <>
                {activeTab === 'Entity Details' && (
                  <div>
                    <dl className='sm:mb-5'>
                      <h5 className='text-xl font-bold dark:text-white'>
                        {entity?.entity_name}
                      </h5>
                    </dl>

                    <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                      <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                        <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                          Entity Type
                        </dt>
                        <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                          {entity?.entity_type}
                        </dd>
                      </div>
                      <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                        <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                          Entity Name
                        </dt>
                        <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                          {entity?.entity_name}
                        </dd>
                      </div>
                      <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                        <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                          Entity Registration Number
                        </dt>
                        <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                          {entity?.entity_reg_no}
                        </dd>
                      </div>
                      <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                        <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'>
                          Entity Tax Number
                        </dt>
                        <dd className='flex items-center text-gray-500 dark:text-gray-400'>
                          {entity?.entity_tax_no}
                        </dd>
                      </div>

                      {producer.entity_reg_cert_url ? (
                        <DocumentViewer
                          name='Registration Certificate'
                          url={producer.entity_reg_cert_url}
                        // onEditClick={() => openUploadModal('Registration Certificate')}
                        />
                      ) : (
                        <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                          <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'></dt>
                          <dd className='text-gray-500 dark:text-gray-400'>
                            No Entity Registration Certificate Found
                          </dd>
                        </div>
                      )}

                      {producer.entity_reg_cert_url ? (
                        <DocumentViewer
                          name='Tax Certificate'
                          url={producer.entity_tax_cert_url}
                        // onEditClick={() => openUploadModal('Tax Certificate')}
                        />
                      ) : (
                        <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                          <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'></dt>
                          <dd className='text-gray-500 dark:text-gray-400'>
                            No Entity Tax Certificate Found
                          </dd>
                        </div>
                      )}

                      {producer.entity_reg_cert_url ? (
                        <DocumentViewer
                          name='Board Resolution'
                          url={producer.board_resolution_url}
                        // onEditClick={() => openUploadModal('Board Resolution')}
                        />
                      ) : (
                        <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                          <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'></dt>
                          <dd className='text-gray-500 dark:text-gray-400'>
                            No Entity Board Resolution Found
                          </dd>
                        </div>
                      )}

                      {producer.entity_reg_cert_url ? (
                        <DocumentViewer
                          name='Profile Document'
                          url={producer.entity_profile_doc_url}
                        // onEditClick={() => openUploadModal('Profile Document')}
                        />
                      ) : (
                        <div className='p-3 bg-gray-100 rounded-lg border border-gray-200 dark:bg-gray-700 dark:border-gray-600'>
                          <dt className='mb-2 font-semibold leading-none text-gray-900 dark:text-white'></dt>
                          <dd className='text-gray-500 dark:text-gray-400'>
                            No Entity Profile Document Found
                          </dd>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            ) : null}
          </div>
          {loading && (
            <div className='text-center'>
              <div role='status'>
                <svg
                  aria-hidden='true'
                  className='inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-green-600'
                  viewBox='0 0 100 101'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                    fill='currentColor'
                  />
                  <path
                    d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                    fill='currentFill'
                  />
                </svg>
                <span className='sr-only'>Please wait...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MartketOfferDetails;
